export interface VisiblePlaceholderProps {
  placeholder?: string
  focused: boolean
  /** A composer's field is focused from the start; without this its placeholder never shows (chat makeover #2718) */
  placeholderWhenFocused?: boolean
}

/** The placeholder the editor shows: documents hide it while focused, a composer keeps it */
export const visiblePlaceholder = ({
  placeholder,
  focused,
  placeholderWhenFocused = false,
}: VisiblePlaceholderProps) => (focused && !placeholderWhenFocused ? undefined : placeholder)
